<template>
    <b-nav-item-dropdown id="home-page-view-dropdown" class="home-page-view-menu">
        <template v-slot:button-content>
            {{ $translate(`${homePageSelectedView}`) }}
            ({{ slideCount }})
        </template>

        <b-dropdown-item
            v-for="option in dropdownOptions"
            :id="`home-page-view-dropdown-option-${option}`"
            :key="option"
            @click="changeHomePageView(option)"
        >
            {{ $translate(`${option}`) }}
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SLIDE_TIME_ATTRIBUTION } from '../../../business/const'

export default {
    name: 'HomePageViewMenu',
    data: () => ({
        viewOptions: ['ongoing', 'finished']
    }),
    computed: {
        ...mapState({
            homePageSelectedView: state => state.timelapse.homePageSelectedView,
            pastSlideMetadata: state => state.timelapse.pastSlideMetadata,
            pastSlideFilter: state => state.timelapse.pastSlideFilter,
            pastSlidesTotalCountWithoutFilter: state =>
                state.timelapse.pastSlidesTotalCountWithoutFilter
        }),
        ...mapGetters({
            activePatientsCount: 'timelapse/activePatientsCount'
        }),
        dropdownOptions() {
            return this.viewOptions.filter(option => option !== this.homePageSelectedView)
        },
        slideCount() {
            if (this.homePageSelectedView === SLIDE_TIME_ATTRIBUTION.FINISHED) {
                return `${
                    (this.pastSlideMetadata && this.pastSlideMetadata.totalCount) ||
                    this.pastSlidesTotalCountWithoutFilter
                }/${this.pastSlidesTotalCountWithoutFilter}`
            }
            return this.activePatientsCount(this.homePageSelectedView)
        }
    },
    methods: {
        async changeHomePageView(view) {
            this.$store.commit('timelapse/homePageSelectedView', view)
        }
    }
}
</script>

<style lang="scss">
.home-page-view-menu {
    .dropdown-menu {
        background-color: $dark-6;

        .dropdown-item {
            padding: 0.25rem 0.5rem;
        }
    }
}
</style>
